import { getProfile } from 'services/endpoints/profile'
import { useProfileCacheStore } from 'store/profileCacheStore'

export async function refreshMyProfileCache() {
  try {
    const profile = await getProfile()
    if (profile?.username) {
      useProfileCacheStore.getState().setProfile(profile.username, profile)
    }
  } catch {}
}
